const Logo = () => {
  return <img src="qtify-logo.png" alt="logo" />;
};

export default Logo